export const RentalReprot_REQUEST = "RentalReprot_REQUEST";
export const RentalReprot_SUCCESS = "RentalReprot_SUCCESS"; 
export const RentalReprot_FAIL = "RentalReprot_FAIL";